module.exports = __webpack_public_path__ + "img/image_4.1d87bc54.jpg";